import { baseErrorMessages } from '@repo/lib/messages/baseErrorMessages';
import { useQuery } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import { GradeService } from './gradeService';
import { GradeKey } from './keys';

export function useGetUserGroupGrades(userId?: number, groupId?: number, enabled = true) {
  const getUserGroupGradesQuery = useQuery({
    queryKey: [GradeKey.USER_GROUP_GRADES, userId, groupId],
    queryFn: () => GradeService.getUserGroupGrades(userId, groupId).then((response) => response.data),
    enabled: enabled && typeof userId === 'number' && typeof groupId === 'number',
    staleTime: 60000,
  });
  const errorMessage = useErrorMessage(getUserGroupGradesQuery.error, baseErrorMessages);
  return { ...getUserGroupGradesQuery, errorMessage };
}
